import { mediaDesktop } from './breakpoints';

export const shadows = {
  s: 'box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.9);',
  l: `
    box-shadow: 0px 32px 32px rgb(41 41 39 / 5%);

    ${mediaDesktop} {
      box-shadow: 0px 48px 48px rgb(41 41 39 / 5%);
    }
  `,
};
